import { adminWorkspaceQueryKeys as e } from "./adminWorkspaceQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { workspaceAdminApi as n } from "@maat/api-main";
//#region src/workspaces/admin/useAdminWorkspaceMembersQuery.ts
var r = (r) => t({
	queryKey: e.members(r),
	queryFn: () => n.getMembers(r),
	enabled: !!r
});
//#endregion
export { r as useAdminWorkspaceMembersQuery };
